import Vue from 'vue'
import App from './App'
import router from './router'

// api
import api from './request/api.js'
// axios
import axios from './request/https.js'
import VueAxios from 'vue-axios'
// vant
import 'vant/lib/index.css';
import Vant from 'vant'
Vue.use(Vant)

// cookie
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// qs
import qs from 'qs';
Vue.prototype.$axios = axios
axios.defaults.baseURL = ''
// animated
import animated from 'animate.css'
Vue.use(animated)
// v-touch
import VueTouch from 'vue-touch';
Vue.use(VueTouch, {
  name: 'v-touch'
});
VueTouch.config.swipe = {
  threshold: 10 //手指左右滑动触发事件距离
}
// 粘贴板
import clipboard from 'clipboard';
Vue.prototype.clipboard = clipboard;
// 防止重复加载
import preventReClick from './lib/preventReClick.js' //防多次点击，重复提交

Vue.prototype.api = api
Vue.config.productionTip = false

// 引入VueX
import store from './store/index.js';

// loading
import './common/loading/loading.css';
import Loading from './common/loading/loading';
Vue.use(Loading);

import "./common/RCLoading/RCLoading.js"; // 注册全局 RCLoading

// // 创建VConsole
// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js